import { ButtonERP, Dialog, TagERP } from "@finanedi.es/storybook"
import { faDownload, faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { postDeclaracionModelo349 } from "api/DeclaracionModelo"
import { DeclaracionModelo349DtoProps } from "api/DTOs/DeclaracionModelo349Dto"
import { Dispatch, SetStateAction, useState } from "react"
import { UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  Modelo349FormModel,
  postModelo349Adapter,
} from "../postModelo349.adapter"

export const ModalPresentarModelo349 = ({
  show,
  setShow,
  watch,
}: {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  watch: UseFormWatch<DeclaracionModelo349DtoProps>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const [loading, setLoading] = useState(false)

  const submitModelo = async (data: Modelo349FormModel) => {
    const formData = postModelo349Adapter(data)
    try {
      setLoading(true)
      const response = await postDeclaracionModelo349({
        declaracion: formData,
      })

      const blob = new Blob([response], { type: "text/plain" })
      const link = document.createElement("a")

      link.href = URL.createObjectURL(blob)
      link.download = "modelo349.txt"
      link.click()

      URL.revokeObjectURL(link.href)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      header={`${t("declaracionModelo349.modal.title")}`}
      headerClassName='!tw-text-lg'
      visible={show}
      onHide={() => setShow(!show)}
      maskClassName='!tw-p-6'
      className='!tw-mt-6 !tw-w-96'
      baseZIndex={30}
      draggable
    >
      <div className='tw-w-full tw-flex tw-gap-3 tw-flex-col tw-text-sm'>
        <TagERP
          color='info'
          icon={<FontAwesomeIcon icon={faInfoCircle} />}
          value={t("modelo390.modal.infoText")}
          className='!tw-rounded-md'
        />
        <div className='tw-w full tw-flex tw-flex-row tw-justify-end'>
          <ButtonERP
            customize={{ type: "primary", size: "md" }}
            label={`${t("taxSummary.declaracion.modal.download")}`}
            onClick={() =>
              submitModelo(values as unknown as Modelo349FormModel)
            }
            icon={<FontAwesomeIcon icon={faDownload} />}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  )
}
export default ModalPresentarModelo349
